<template>
  <ul class="blog-post-list">
    <li v-for="post in postsWithCover" :key="post.slug" class="blog-post-list__item">
      <a :href="`/${post.slug}/`" class="blog-post-list__link">
        <BlogCardCover
          :image="post.coverSrc"
          :alt="post.title"
          :theme="post.coverTheme"
          :label="post.coverLabel" />
        <div class="blog-post-list__body">
          <time :datetime="post.publishedAt">{{ formatBlogDate(post.publishedAt) }}</time>
          <h3>{{ post.title }}</h3>
          <p>{{ post.description }}</p>
        </div>
      </a>
    </li>
  </ul>
</template>

<script>
import BlogCardCover from './BlogCardCover.vue'
import { formatBlogDate } from '@/utils/blog'
import { getPostCoverSrc } from '@/constants/blogCovers'

export default {
  name: 'BlogPostList',
  components: { BlogCardCover },
  props: {
    posts: { type: Array, required: true },
  },
  computed: {
    postsWithCover() {
      return this.posts.map((post) => ({
        ...post,
        coverSrc: post.coverSrc || getPostCoverSrc(post.slug),
      }))
    },
  },
  methods: { formatBlogDate },
}
</script>
